import { SimpleRevealingAnimation } from "../../../../../shared/components/simple-revealing-animation";
import { FormTitle } from "../../../typography";
import { ButtonLink } from "../../../../../shared/components/link/ButtonLink";
import { TextLink } from "../../../../../shared/components/link/TextLink";
import { submitPageButtons, closeButton } from "./styles.css";
import text from "../resources/text.json";
import { useLanguage } from "../../../../../providers/language/context";

type SubmitViewProps = {
  changeFormView: () => void;
};

export const SubmitView = ({ changeFormView }: SubmitViewProps) => {
  const { language } = useLanguage();
  const { close, successMessage, anotherRequest } =
    text[language as keyof typeof text];

  return (
    <SimpleRevealingAnimation duration={0.5}>
      <div>
        <FormTitle>{successMessage}</FormTitle>
        <div className={submitPageButtons}>
          <ButtonLink onClick={changeFormView}>{anotherRequest}</ButtonLink>
          <TextLink
            className={closeButton}
            noUnderline
            onClick={() => window.history.back()}
          >
            {close}
          </TextLink>
        </div>
      </div>
    </SimpleRevealingAnimation>
  );
};
